module.exports = __webpack_public_path__ + "static/media/button-sort-active.81aabf27.png";